import * as React from "react";
const SvgFiBrandsIndesign = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-indesign_svg__a)">
      <path
        fill="#151A2D"
        d="M20.573.3H4.427C1.98.3 0 2.2 0 4.55v14.9c0 2.35 1.98 4.25 4.427 4.25h16.146C23.02 23.7 25 21.8 25 19.45V4.55C25 2.2 23.02.3 20.573.3M9.083 16.68c0 .11-.052.16-.146.16H6.897c-.094 0-.136-.05-.136-.16V6.42c0-.09.053-.13.146-.13h2.032c.062-.01.124.03.135.1.01.01.01.02.01.03zm9.302-.3c-.541.22-1.114.38-1.698.48-.52.09-1.062.14-1.604.14-.77.01-1.541-.14-2.24-.45a3.6 3.6 0 0 1-1.572-1.36c-.386-.61-.573-1.37-.573-2.28a4 4 0 0 1 .573-2.11 4.25 4.25 0 0 1 1.656-1.55c.73-.39 1.604-.58 2.636-.58.052 0 .124 0 .218.01s.198.01.323.02V5.54c0-.07.031-.11.104-.11h2.115c.052-.01.094.03.104.07v9.54c0 .18.01.38.02.6.022.21.032.41.043.58 0 .07-.032.13-.105.16m-2.906-5.85c-.406 0-.812.08-1.177.26-.354.17-.656.42-.885.74-.23.32-.344.75-.344 1.27-.01.35.052.7.177 1.03.104.27.26.51.469.71.198.18.437.32.708.4.281.09.573.13.865.13.156 0 .302-.01.437-.02.136.01.26-.01.375-.05v-4.4c-.094-.02-.187-.04-.281-.05-.115-.01-.23-.02-.344-.02"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-indesign_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsIndesign;
